import React, {useEffect, useState} from 'react';
import s from "./decay_sim_style.module.css";
import {Images, Text} from "../../AssetReferences";
import {ImageLink} from "../../components/image_link";
import {Download, Media} from "./decay_sim_data";
import {PageButton} from "./decay_sim";

export default function DownloadPage({onBackButtonPressed, alpha})
{
    const [platform, setPlatform] = useState("")
    
    function changePlatform(_platform)
    {
        setPlatform(_platform);
    }
    
    function getDownload(_platform)
    {
        switch (platform)
        {
            case "Windows": return Download.Windows;
            case "Mac": return Download.Mac;
            default: return null;
        }
    }
    
    return (
        <div id={"DownloadPage"}>
            <PageButton onClick={onBackButtonPressed} text={"BACK"}/>

            <p>Select your platform below.</p>
            
        
            <a style={{textDecoration:"underline #0000ec"}} href={getDownload(platform)}>
                <PlatformSelector onClick={changePlatform}/>
            </a>
            
            <DisplayPlatformContent platform={platform}/>
           
        </div>
       
    )
}

function PlatformSelector({onClick})
{
    return (
        <div id={"platform_selector"} className={s.platform_selector}>
            <div className={s.platform_select_button_container}>              
                <button className={s.platform_select_button} onFocus={() => onClick("Windows")} onMouseEnter={() => onClick("Windows")} onClick={() => onClick("Windows")}>WINDOWS</button>
                <button className={s.platform_select_button} onFocus={() => onClick("Mac")}  onMouseEnter={() => onClick("Mac")}  onClick={() => onClick("Mac")}>MAC</button>                
            </div>
         
        </div>
    )
}

function DisplayPlatformContent({platform})
{   
    const [selected, setSelected] = useState("")

    useEffect(() => {
        setSelected(platform);
    }, [platform]);

    function Mac()
    {
        return (
            <div id={"mac"}>
                <ol>
                    <li>Press the button above to start the download, if it hasn't already.</li>
                    <li>A popup may appear saying DecaySim can't be opened because Apple can't check it for malicious software. Press ok, then
                        open your security settings and the option to allow DecaySim to open should appear at the bottom of the window.</li>
                    <li>Open DecaySim through Spotlight or by opening it wherever it was downloaded.</li>
                </ol>
            </div>
        )
    }
    
    function Windows()
    {
        return (
            <div id={"windows"}>
                <ol>
                    <li>Press the button above to start the download, if it hasn't already.</li>
                    <li>Extract the "Windows" folder to a location of your choice.</li>
                    <li>Open the extracted folder and open "decay sim.exe".</li>
                </ol>
            </div>
        )
    }
    
    function getPlatform()
    {
        switch (selected)
        {
            case "Mac": return <Mac/>
            case "Windows": return <Windows/>
            default: return null;
        }
    }


    
    return (
        <div className={s.platform_help_container}>
            {getPlatform()}
            
            {/*<div className={s.download_icon_container}>*/}
            {/*    <DownloadIcon/>*/}
            {/*</div>*/}
        </div>
    )
    
}